<template>
  <ClientLogoForm />
</template>
<script>
import ClientLogoForm from "@/views/client-logos/ClientLogoForm.vue";

export default {
  components: { ClientLogoForm },
};
</script>
